<template lang="pug">

  section.view-more
    .video
      video(src="content/loop-ford-viewmore.mp4" muted autoplay loop playsinline)
    .view-wrapper
      .view-figure
        h2 Conoce más sobre los modelos de Ford Ranger
        a.btn.btn-more(href="https://www.ford.cl/pickups/ranger/?ref=latercera-mtonline" ) Más Información

</template>

<script>
  export default  {

}
</script>

<style scoped lang="scss">
  .view-more {
    height: 60vh;
    overflow: hidden;
    position: relative;
    @media all and (max-width: 800px){
      min-height: 50vh;
    }
    .video{
      position: relative;
      padding-bottom: 56.25%;
      padding-top: 0;
      height: 0;
      @media all and (max-width: 800px){
        min-height: 80vh;
        padding: 0;
        height: auto;
      }
      &:before{
        content: '';
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url(../assets/grid.png);
        position: absolute;
        z-index: 2;
      }
      iframe,
      video{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        @media all and (max-width: 800px){
          object-fit: cover;
        }
      }
    }
    h2{
      color: black;
      font-family: 'Ford Light';
      font-weight: normal;
      font-size: 2.375rem;
      text-transform: uppercase;
      @media all and (max-width: 800px){
        font-size: 2rem;
      }
      small {
        display: block;
        font-size: 2rem;
        @media all and (max-width: 800px){
          font-size: 1.2rem;
        }
      }
    }
  }
  .btn-more{
    background-color: #2d96cd;
    display: inline-block;
    padding: 1rem;
    color: white;
    border-radius: 0;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 3px;
    font-weight: bold;
    margin: 20px 0;
    transition-property: color, background-color;
    transition-timing-function: ease;
    &:hover{
      color: black;
      background-color: white;
    }
  }
  .view-wrapper{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .view-figure{
    max-width: 30%;
    text-align: center;
    background-color: rgba(255,255,255,0.9);
    padding: 1rem;
    @media all and (max-width: 800px){
      max-width: 80%;
    }
  }
</style>
